<script>
  import { statusLabel } from "./engine";
  export let status;
  const COLORS = {
    active: "success",
    temporarily_reactivated: "success",
    incoming: "info",
    damaged: "warning",
    broken: "danger",
    lost: "danger",
    retired: "secondary",
    donated: "secondary",
    sold: "dark",
  };
</script>

<span class="badge bg-{COLORS[status] || 'light'}">{statusLabel(status)}</span>
